import { render, staticRenderFns } from "./MasterDataChassisVendor.vue?vue&type=template&id=8c5842f6&scoped=true"
import script from "./MasterDataChassisVendor.vue?vue&type=script&lang=js"
export * from "./MasterDataChassisVendor.vue?vue&type=script&lang=js"
import style0 from "./MasterDataChassisVendor.vue?vue&type=style&index=0&id=8c5842f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c5842f6",
  null
  
)

export default component.exports